import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { XCircle, ArrowLeft, RefreshCw } from 'lucide-react';

export function BillingCancelPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <Card className="w-full max-w-2xl">
        <CardHeader className="text-center">
          <div className="flex items-center justify-center mb-4">
            <div className="flex-shrink-0 w-16 h-16 rounded-full bg-orange-100 flex items-center justify-center">
              <XCircle className="w-8 h-8 text-orange-600" />
            </div>
          </div>
          <CardTitle className="text-2xl font-bold text-foreground">Payment Cancelled</CardTitle>
          <CardDescription className="text-lg">
            Your subscription upgrade was cancelled
          </CardDescription>
        </CardHeader>

        <CardContent className="space-y-6">
          <div className="bg-muted/50 rounded-lg p-6 text-center">
            <h3 className="font-semibold text-foreground mb-2">Don't worry!</h3>
            <ul className="text-sm text-muted-foreground space-y-2">
              <li>• No charges were made to your account</li>
              <li>• Your current plan remains active</li>
              <li>• You can try upgrading again anytime</li>
              <li>• All your data is safe and secure</li>
            </ul>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <Button
              onClick={() => navigate('/organization')}
              variant="outline"
              className="flex items-center justify-center"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Settings
            </Button>
            <Button
              onClick={() => navigate('/dashboard')}
              className="flex items-center justify-center"
            >
              Go to Dashboard
            </Button>
            <Button
              onClick={() => window.history.back()}
              variant="outline"
              className="flex items-center justify-center"
            >
              <RefreshCw className="w-4 h-4 mr-2" />
              Try Again
            </Button>
          </div>

          <div className="text-center border-t pt-6">
            <h4 className="font-medium text-foreground mb-2">Need Help Choosing a Plan?</h4>
            <p className="text-sm text-muted-foreground mb-4">
              Our team is here to help you find the perfect plan for your organization
            </p>
            <Button variant="link" size="sm">
              Contact Sales Team
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}